import type React from 'react';

import { Button, Card, CardBody, Text } from '@change/ds-core-ui';
import { ErrorMessage } from '@change/ds-forms';

import { MembershipAmountSelector } from './components/MembershipAmountSelector';
import { useChangeContributionsForm } from './hooks/useChangeContributionsForm';

export const ChangeContributionsForm: React.FC = () => {
	const {
		data: { title, isDisabled, loading, formError, buttonLabel },
		actions: { submit },
	} = useChangeContributionsForm();

	return (
		<Card className="w-full max-w-[500px]">
			<CardBody className="flex flex-col gap-8">
				<Text as="h3" fontWeight="bold" variant="heading" size="xx-small">
					{title}
				</Text>

				<form className="flex flex-col gap-2" data-qa="change-contribution-form" onSubmit={submit}>
					<MembershipAmountSelector />

					{formError && <ErrorMessage size="small">{formError}</ErrorMessage>}

					<Button
						className="mt-4 w-full"
						type="submit"
						variant="primary"
						disabled={isDisabled}
						loading={loading}
						data-testid="submit-contribution-amount-button"
						data-qa="submit-contribution-amount-button"
					>
						{buttonLabel}
					</Button>
				</form>
			</CardBody>
		</Card>
	);
};
